/**
 * @generated SignedSource<<14f36ecf59ff54b837e8c7b6fc5f50a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getShoppablePhotoData_tags$data = {
  readonly similarItems: {
    readonly items: ReadonlyArray<{
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "getShoppablePhotoData_tags";
};
export type getShoppablePhotoData_tags$key = {
  readonly " $data"?: getShoppablePhotoData_tags$data;
  readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_tags">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getShoppablePhotoData_tags"
};

(node as any).hash = "9a200cd0a99f71a09f14d75bd549281c";

export default node;
